import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS, Validator, AbstractControl } from "@angular/forms";
import * as moment from "moment";

@Directive({
  selector: "[beforeDate]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: BeforeDateValidatorDirective,
      multi: true
    }
  ]
})
export class BeforeDateValidatorDirective implements Validator {
  @Input("beforeDate") before: Date | string;

  validate(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) return null;
    return moment(control.value).isValid() &&
      moment(this.before).isValid() &&
      moment(control.value).isSameOrBefore(this.before)
      ? null
      : { beforeDate: { value: control.value } };
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/beforedatevalidator.directive.ts